/**
 * Tencent Cloud Captcha Configuration
 */

export const CAPTCHA_APP_ID = '195559255'; // Tencent Cloud CaptchaAppId 